import styled from 'styled-components';
import {
  whiteColor,
  boldFont,
  screenSize,
  regularFont,
  secondaryColor,
  appHeaderColor,
} from '@app/styles';
import DefaultImageUrl from '@app/assets/images/user_profile.svg';
import DropDownUrl from '@app/assets/images/dropdownarrow.svg';

type ImageProps = {
  image?: string;
  size?: string;
};
type Props = {
  show?: boolean;
  toggle?: boolean;
};
type ProgressProps = {
  percentage: number;
};
export const BackgroundContainer = styled.div`
  background-color: ${appHeaderColor};
  top: 0;
  left: 0;
  width: 100%;
  z-index: 3;
  position: fixed;
`;

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  height: 60px;
  padding: 0 5px 0 5px;
  color: ${whiteColor};
  @media (${screenSize.tablet}) {
    height: 60px;
    display: flex;
    margin: 0 20px 0 20px;
    justify-content: space-between;
  }
`;
export const InnerContainer = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  position: relative;
`;
export const HeaderContainer = styled.div`
  height: 100%;
  width: 100%;
  @media (${screenSize.tablet}) {
    width: 100%;
    height: 100%;
  }
`;

export const Title = styled.div`
width:100%
  display: none;
font-size: 18px;
color: #FFFFFF;
letter-spacing: 0.22px;
line-height: 21px;
  cursor:pointer;
  @media (${screenSize.tablet}) {
    display: block;
    cursor:pointer;
  }
`;

export const MobileTitle = styled.div`
  font-size: 21px;
  ${boldFont};
  @media (${screenSize.tablet}) {
    display: none;
  }
`

export const MenuIcon = styled.div`
  position: absolute;
  left: 15px;
  @media (${screenSize.tablet}) {
    display: none;
  }
`;
export const ProfileIcon = styled.div`
  width: 36px;
  height: 36px;
  margin-left: 10px;
  border-radius: 50%;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  cursor: pointer;
  background-image: url(${DefaultImageUrl});
  ${({ image, size }: ImageProps) => {
    if (image && size === 'large') {
      return `background-image:url(${image});
              width:50px;
              height:50px;`;
    } else if (image) {
      return `background-image:url(${image});`;
    } else if (size === 'large') {
      return `width:50px;
              height:50px;`;
    }
  }}
`;
export const Text = styled.div`
  color:${whiteColor};
  padding-right:15px;
  display:none;
  cursor:pointer;
  @media (${screenSize.tablet}){
    display:block;
  }
`;
export const SubTitle = styled.span`
  color: ${whiteColor};
  font-size: 18px;
  ${regularFont};
`;
export const HeaderDropDown = styled.div`
  position: fixed;
  background: ${whiteColor};
  z-index: 3;
  top: 65px;
  height: auto;
  width: 100%;
  border: 1px solid #dce0e8;
  right: 0;
  box-shadow: 0 11px 20px 0 rgba(47, 54, 65, 0.5);
  @media (${screenSize.tablet}) {
    top: 100%;
    position: absolute;
    width: 300px;
  }
`;
export const DropDownOption = styled.div`
  font-size: 15px;
  color: #3a435e;
  height: 46px;
  display: flex;
  align-items: center;
  padding: 10px 15px 10px;
  cursor: pointer;
  svg {
    margin-right: 5px;
    g {
      fill: #80868b;
    }
  }
`;
export const DropdownHeader = styled.div`
  height: 74px;
  display: inline-flex;
  align-items: center;
  flex-direction: row;
  padding: 10px 15px;
`;
export const LogoutText = styled.span`
  color: ${secondaryColor};
  font-size: 15px;
  display: flex;
  align-items: center;
  svg {
    g {
      fill: none;
    }
  }
`;
export const Name = styled.p`
  font-size: 16px;
  color: #3a435e;
  margin: 0 10px 5px;
`;
export const Email = styled.p`
  font-size: 14px;
  color: #9398a8;
  margin: 0 10px 5px;
  text-overflow: ellipsis;
  overflow: hidden;
  width: 80%;
`;
export const UploadIcon = styled.div`
  margin-right: 20px;
  padding-right: 20px;
  border-right: 1px solid #fff;
  cursor: pointer;
  height: 30px;
  align-items: center;
  display: flex;
  svg {
    width: 30px;
    height: 30px;
    margin-right: 10px;
    margin-left: 10px;
    path {
      fill: #fff;
    }
  }
`;
export const EventOuterContainer = styled.div`
  opacity: 0;
  pointer-events: none;
  ${({ show }: Props) => {
    if (show) {
      return `opacity:1;
                pointer-events:all;`;
    }
  }}
`;
export const ProgressContainer = styled.div`
  height:40px;
  width:90%;
  right:5px;
  display:flex;
  align-items:center;
  justify-content:space-between;
  position:fixed;
  bottom:5px;
  background:#FFF;
  border-radius:4px;
  transition:all 0.3s linear;
  color: #3a435e;
  box-shadow: 0 -11px 20px 0 rgba(47, 54, 65, 0.5);
  padding-right: 5px;
  svg{
    width:24px;
    height:24px;
  }
  ${({ toggle }: Props) => {
    if (toggle) {
      return `width: 110px;
      align-items: center;
      justify-content: end;
      min-width: 80px;
      `;
    }
  }}
 
  @media (${screenSize.tablet}){
    width:320px;
    right:20px;
    bottom:initial;
    position:fixed;
    box-shadow: none;
    ${({ toggle }: Props) => {
      if (toggle) {
        return `width: 90px;
      align-items: center;
      justify-content: end;
      min-width: 80px;
      `;
      }
    }}
}

`;
export const ProgressOuter = styled.div`
  position: absolute;
  right: 0;
  top: 5px;
  .progressOuter {
    position: absolute;
    right: 0;
    top: 5px;
  }
`;
export const ProgressInnerContainer = styled.div`
  width: 65%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;
export const Count = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  margin-top: 5px;
  width: 100%;
  color: #3a435e;
`;
export const ToggleIcon = styled.div`
  width: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-right: 1px solid #dce0e8;
  height: 100%;
  svg {
    width: 30px;
    height: 30px;
    position: absolute;
    transform: rotate(-90deg);
  }
  transition: all 0.3s linear;
  transition-delay: 0.3s;
  cursor: pointer;
  ${({ toggle }: Props) => {
    if (toggle) {
      return `svg{
        transform:rotate(90deg);
      }`;
    }
  }}
`;
type ProgressType = {
  type?: 'aggregate' | 'single';
};
export const ProgressBar = styled.div`
  height: 6px;
  width: 100%;
  position: relative;
  background: ${whiteColor};
  border-radius: 4px;
  border: 1px solid #dce0e8;
  @media (${screenSize.tablet}) {
    height: 8px;
  }
  ${({ type }: ProgressType) => {
    if (type === 'single') {
      return `
                      border:1px solid #dce0e8;
                      position:absolute;
                      bottom:0px;
                      left:0;
                      width:100%;
              `;
    }
  }}
`;
export const Progress = styled.div`
  background: #40ddc6;
  position: relative;
  height: 100%;
  ${({ percentage }: ProgressProps) => {
    if (percentage) {
      return `width:${percentage}%;`;
    } else {
      return `width:0`;
    }
  }}
`;
export const Percentage = styled.span`
  font-size: 13px;
  line-height: 16px;
`;
export const CloseIcon = styled.div`
  div {
    div {
      width: 16px;
      div {
        height: 2px;
        background-color: red;
      }
    }
  }
`;
export const FilesList = styled.div`
  min-height: 200px;
  overflow-y: auto;
  position: absolute;
  bottom: 103%;
  left: 0;
  width: 100%;
  height: auto;
  background: #fff;
  color: #3a435e;
  box-shadow: 0 -11px 20px 0 rgba(47, 54, 65, 0.5);
  @media (${screenSize.tablet}) {
    top: 103%;
    box-shadow: 0 11px 20px 0 rgba(47, 54, 65, 0.5);
  }
`;

export const PreviewFile = styled.div`
  height: 52px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 15px;
  border-top: 1px solid #dee4e8;
  position: relative;
`;
export const FileName = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  svg {
    margin-right: 8px;
  }
  div {
    width: 80%;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
  @media (${screenSize.tablet}) {
    width: 60%;
  }
`;
export const ActionIcons = styled.div`
  display: flex;
  align-items: center;
  svg {
    margin-left: 10px;
    width: 18px;
    height: 18px;
  }
`;
export const DropDownArrow = styled.div`
  height: 24px;
  width: 24px;
  margin-left: 5px;
  background-image: url(${DropDownUrl});
  background-position: 0 center;
  background-repeat: no-repeat;
  cursor: pointer;
`;
